// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3IsZD","errorLogs":"styles_errorLogs__3X7kv"};